import {AuthService} from 'hasta-la-vista-middleware-api/service'
import {Utils} from 'hasta-la-vista-ui-core'

export default {
	props: {
		signUp: Boolean,
	},
	data() {
		return {
			loading: false,
			username: null,
			password: null,
			isGuest: true,
			signUpChange: this.signUp,
		}
	},

	mounted() {
		AuthService.addObserver(this, AuthService.PROFILE_CHANGED, this.checkUser); // listen for changes to the user:
    this.checkUser(); // get and set the user.
	},

	methods: {
		checkUser(){
        	AuthService.user().then( (user)=> this.isGuest = user.isGuest() )
    	},

		login: function () {
			this.loading = true

	        AuthService.signIn(this.username,this.password).then( (user) => {
	        	this.loading = false
            window.scroll({top: 0, left: 0})
	        }, (error)=> {
	        	this.loading = false
	        })
	    },

	    toggleSignUp() {
	    	if(this.signUp) {
	    		this.signUpChange = false
	    	} else {
	    		this.signUpChange = true
	    	}
	    }
	},

	watch: {
		signUpChange: {

            handler: Utils.debounce(function () {
                this.$emit('changed', [this.signUpChange])
                this.loading = false
            }, 300),
            deep: true
        },
	}
}


// WEBPACK FOOTER //
// ./src/components/profile/signin/signin.js